import { toast } from "react-toastify";
import { BaseApplicationService } from "../../domain/base/base-application-service";
import apiClient from "../../apis/api-client";
import { getFriendlyErrorMessage } from "../../util/error-message-mapper";
import { Shortcut } from "../../domain/ttzk-portal";
import { reportTtzkPortalRelatedError } from "../../domain/ttzk-portal/util/error";

export type ShortcutListContextProps = {
  shortcuts: Array<Shortcut>;
  fetchShortcutByOrgId: (orgId: string) => Promise<void>;
};

export class TtzkPortalShortcutListService extends BaseApplicationService<ShortcutListContextProps> {
  state = {
    shortcuts: [],
    fetchShortcutByOrgId: this.fetchShortcutByOrgId.bind(this),
  };

  async fetchShortcutByOrgId(orgId: string) {
    try {
      const { data } = await apiClient.ttzkPortal.listShortcutsByOrgId(orgId);
      this.setState({
        shortcuts: data?.shortcuts,
      });
    } catch (error) {
      reportTtzkPortalRelatedError(error);
      const friendlyMessage = getFriendlyErrorMessage(error);
      toast.error(
        `ショートカットの一覧の取得に失敗しました: ${friendlyMessage}`,
      );
    }
  }
}
